import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  let data = isSuccessResponse(response)
  return data
}

const getConfigListInsertRequest = (mid: string, configs: any[], isUpdateRequired: boolean) => {
  return {
    mid: mid,
    configListDetails: configs,
    updateRequired: isUpdateRequired ? 'Y' : 'N',
  }
}

const insertConfigList = (mid: string, configs: any[], tokens: any, isUpdateRequired: boolean) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.configListInsert),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getConfigListInsertRequest(mid, configs, isUpdateRequired),
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { insertConfigList }
